// Generated by scripts/fetch-laws.ts from lawsofux.com and timsommer.be. Do not edit directly.
import type { Law } from "../types";

export const brooksLaw: Law = {
  slug: "brooks-law",
  title: "Brook's Law",
  definition: "Adding manpower to a late software project makes it later.",
  category: "theory",
  color: "#e579c4",
  labels: ["management","software-engineering"],
  copy: ["Most developers will -either knowingly or unknowingly- have experience with Brook's law, which states:","If a project is running late, simply adding manpower will most likely have disastrous results. Looking and reviewing the level of programming efficiency, the software methodology, the technical architecture, etc. will almost always have better outcomes. Or not, which probably means Hofstadter's Law is also in play."],
  sources: ["https://www.timsommer.be/famous-laws-of-software-development/"],
  related: [],
};
